import React, { useState } from "react";
import { Formik, Field } from "formik";
import axios from "axios";
import * as Yup from "yup";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import MainSidebar from "../Mainsidebar";
import UserNavbar from "../UserNavbar";
import UserFooter from "../UserFooter";
//import "../../Style/NewLead.css";
import { path_url } from "../../Config/config";

function FeatureRequestForm() {
  const navigate = useNavigate();
  const [hamburger, sethamburger] = useState(false);
  const [isRightMenu, setisRightMenu] = useState(false);
  const [isSearchShow, setIsSearchShow] = useState(false);
  const [fullScreen, setFullScreen] = useState(true);
  const handleScreenEnter = () => {
    setFullScreen(false);
    document.body.requestFullscreen();
  };
  const handleScreenExit = () => {
    setFullScreen(true);
    document.exitFullscreen();
  };
  const handelShow = () => setIsSearchShow(!isSearchShow);
  const handelRightMenuShow = () => setisRightMenu(!isRightMenu);
  const handleclickonbutton = (hamburger) => {
    if (document.documentElement.clientWidth <= 800)
      return { width: "100%", left: "0rem" };
    else
      return {
        width: !hamburger && "-webkit-fill-available",
        left: !hamburger && "3.7rem",
      };
  };
  const handleclickonbutton1 = (hamburger) => {
    if (document.documentElement.clientWidth <= 800) {
      return { display: hamburger && "none" };
    }
  };

  // Cancel — navigate back to the previous page, discarding unsaved changes.
  // Falls back to the dashboard if there is no previous page in history.
  const handleCancel = () => {
    if (window.history.length > 2) {
      navigate(-1);
    } else {
      navigate("/crm-dashboard");
    }
  };

  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    title: Yup.string().required("Title is required"),
    description: Yup.string().required("Description is required"),
    priority: Yup.string().oneOf(["Low", "Medium", "High"]),
    attachment: Yup.mixed().nullable(),
  });

  const priorities = [
    { value: "Low", label: "Low" },
    { value: "Medium", label: "Medium" },
    { value: "High", label: "High" },
  ];

  return (
    <>
      <div className="con1 d-flex">
        <div className="subcon1" style={handleclickonbutton1(hamburger)}>
          <MainSidebar hamburger={hamburger} sethamburger={sethamburger} />
        </div>
        <div className="subcon2" style={handleclickonbutton(hamburger)}>
          <UserNavbar
            hamburger={hamburger}
            sethamburger={sethamburger}
            handelRightMenuShow={handelRightMenuShow}
            handelShow={handelShow}
            isSearchShow={isSearchShow}
            handleScreenEnter={handleScreenEnter}
            handleScreenExit={handleScreenExit}
            fullScreen={fullScreen}
          />

          <div className="mt-2">
            <Formik
              initialValues={{
                name: "",
                email: "",
                title: "",
                description: "",
                priority: "Low",
                attachment: null,
              }}
              validationSchema={validationSchema}
              onSubmit={async (values, { resetForm }) => {
                try {
                  const token = localStorage.getItem("accessToken");
                  const adminId = localStorage.getItem("adminId");
                  const formData = new FormData();
                  Object.keys(values).forEach((key) => {
                    formData.append(key, values[key]);
                  });

                  const response = await axios.post(
                    `${path_url}/feature-requests`,
                    formData,
                    {
                      headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                      },
                    },
                  );

                  if (response.data.statusCodeValue === 200) {
                    toast.success(
                      "Feature Request Form submitted successfully",
                    );
                    console.log("feature", response);
                    resetForm();
                  } else {
                    toast.error(response.data.body);
                  }
                } catch (error) {
                  toast.error("An error occurred while submitting the form");
                  console.error(error);
                }
              }}
            >
              {(formik) => (
                <form action="" onSubmit={formik.handleSubmit}>
                  <fieldset style={{ marginBottom: "5rem" }}>
                    <div className="col-12 d-flex justify-content-center">
                      <div className="bg-white col-11 cont">
                        <div className="d-flex justify-content-center">
                          <div
                            style={{ boxShadow: "0 1px 1px lightgray" }}
                            className=" col-12 m-1 mt-2 mb-3  elevation-2"
                          >
                            <p
                              style={{ color: "gray" }}
                              className=" p-1 m-0 custom-font-size"
                            >
                              <strong>Feature Request</strong>
                            </p>
                          </div>
                        </div>
                        <div className="d-flex flex-wrap">
                          <div className="col-12 col-md-6 pl-0 pr-0 ">
                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Name</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8  forms">
                                <input
                                  type="text"
                                  placeholder="Enter your name"
                                  name="name"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.name}
                                />
                                {formik.touched.name && formik.errors.name && (
                                  <span style={{ color: "red" }}>
                                    {formik.errors.name}
                                  </span>
                                )}
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Email</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8  forms">
                                <input
                                  type="text"
                                  placeholder="Enter your email address"
                                  name="email"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.email}
                                />
                                {formik.touched.email &&
                                  formik.errors.email && (
                                    <span style={{ color: "red" }}>
                                      {formik.errors.email}
                                    </span>
                                  )}
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Title</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8  forms">
                                <input
                                  type="text"
                                  placeholder="Enter feature request title"
                                  name="title"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.title}
                                />
                                {formik.touched.title &&
                                  formik.errors.title && (
                                    <span style={{ color: "red" }}>
                                      {formik.errors.title}
                                    </span>
                                  )}
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Priority</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8">
                                <Field
                                  className="selectBox custom-select "
                                  as="select"
                                  name="priority"
                                  id="priority"
                                  defaultValue={priorities[0].value}
                                >
                                  {priorities.map((option) => (
                                    <option
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </option>
                                  ))}
                                </Field>
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-md-6 pl-0 pr-0">
                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Description</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8  forms">
                                <textarea
                                  placeholder="Enter feature request description"
                                  name="description"
                                  rows={5}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.description}
                                />
                                {formik.touched.description &&
                                  formik.errors.description && (
                                    <span style={{ color: "red" }}>
                                      {formik.errors.description}
                                    </span>
                                  )}
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Attachment</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8  forms">
                                {/* Native file inputs don't support the placeholder
                                    attribute — retaining default browser text
                                    ("No file chosen" / "Choose File") per the
                                    ticket's fallback note. */}
                                <input
                                  type="file"
                                  name="attachment"
                                  onChange={(event) => {
                                    formik.setFieldValue(
                                      "attachment",
                                      event.currentTarget.files[0],
                                    );
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-sm-12 d-flex mb-2">
                          <div className="col-12 col-sm-6 d-flex justify-content-center p-2">
                            <button
                              type="button"
                              className="btn btn-sm btn-light border rounded border-gray"
                              onClick={handleCancel}
                            >
                              Cancel
                            </button>
                          </div>
                          <div className="col-12 col-sm-6 d-flex justify-content-center p-2">
                            <button
                              type="submit"
                              className="btn btn-sm border rounded border-gray btn-info "
                              style={{ backgroundColor: "" }}
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </form>
              )}
            </Formik>
          </div>
          <UserFooter />
          <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
          />
        </div>
      </div>
    </>
  );
}

export default FeatureRequestForm;